const messages = {
  title: "Vouchers",
  short_description:
    "Vous y trouverez la liste de vos bons d'achat. Vous pouvez les partager avec vos clients. Les bons d'achat sont à usage unique.",
  table: {
    headers: {
      voucher: "Codes de bon",
      company: "Entreprise",
      street: "Rue",
      postcode: "Code postal",
      location: "Lieu",
      solved_at: "Date",
      points: "Nombre de points via le code",
    },
  },
  exchange: {
    title: "Entrez votre code pour obtenir des points",
    pointsLabel: "Entrez le code ici :",
    result: "Nombre de points:",
  },
};

export default {
  messages,
};
